export default __webpack_public_path__ + "static/media/f18.5bd32e57.png";